import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Typography } from "@material-ui/core";
import UnoButton from "../../utils/UnoButton";
import { unoTheme } from "../../../assets/styles/unoTheme";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTextField from "../../utils/MyTextField";

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import EventIcon from '@material-ui/icons/Event';

import { useDispatch } from "react-redux";
import allActions from "../../../actions";

import CircularProgress from '@material-ui/core/CircularProgress';

import {
    getArrayMonthsWithNames,
    applyMaskAmount,
    parseFloatByPtCurrency
} from "../../utils/utils";

import { SelicCdiIpcaAPI } from '../../../API/selicCdiIpca';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
        backgroundColor: unoTheme.hoverTable,
    },
    main: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        '& .MuiTableContainer-root': {
            height: 'calc(100% - 170px)',
        },
    },
    leftPadding24: {
        paddingLeft: theme.spacing(3),
    },
    bottom: {
        height: '70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    spacingRight2: {
        marginRight: theme.spacing(2),
    },
    table: {
        height: 'calc(100% - 1px)',
        '& .MuiTableHead-root': {
            '& .MuiTableCell-root': {
                background: 'white',
            }
        }
    },
    detailRow: {
        cursor: 'pointer',
        '& > *': {
            padding: '3px 16px 3px 16px !important',
            textTransform: 'uppercase',
            color: unoTheme.defaultTextColor,
            fontWeight: 400,
            fontSize: '12px',
        },
        '& .MuiTableCell-root:first-child': {
            paddingLeft: '24px !important',
        }
    },
    leftHeader: {
        display: 'flex',
        flexDirection: 'column',
    },
    dateLabel: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#1C2228',
        '& .MuiSvgIcon-root': {
            marginRight: theme.spacing(1),
        }
    },
    accountLabel: {
        fontSize: '14px',
        color: unoTheme.secondaryColor,
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2),
    },
    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .progress': {
            color: unoTheme.mainColor
        }
    },
}));

export default function NewSelicCdiIpca(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { content } = props;

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [months] = useState(getArrayMonthsWithNames());

    const [inputs, setInputs] = useState([
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
    ]);

    function initInputs(data) {
        const newInputs = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(m => ({
            selic_cdi_ipca_id: data.records[m] && data.records[m].id ? data.records[m].id : null,
            month: m,
            year: data.year,
            selic: data.records[m] && data.records[m].selic != null ? applyMaskAmount(data.records[m].selic) : null,
            cdi: data.records[m] && data.records[m].cdi != null ? applyMaskAmount(data.records[m].cdi) : null,
            ipca: data.records[m] && data.records[m].ipca != null ? applyMaskAmount(data.records[m].ipca) : null,
        }));
        setInputs(newInputs);
    }

    function handleChange(field, value, index) {
        const newInputs = [...inputs];
        newInputs[index][field] = value;
        newInputs[index].statusChange = true;
        setInputs(newInputs);
    }

    async function doSave(ipts) {
        setOpenBackdrop(true);

        const changed = ipts.filter(el => el.statusChange);
        let allSuccess = true;

        for (let i = 0; i < changed.length; i++) {
            const row = changed[i];
            const payload = {
                id: row.selic_cdi_ipca_id,
                month: row.month,
                year: row.year,
                selic: row.selic != null ? parseFloatByPtCurrency(row.selic) : null,
                cdi: row.cdi != null ? parseFloatByPtCurrency(row.cdi) : null,
                ipca: row.ipca != null ? parseFloatByPtCurrency(row.ipca) : null,
            };

            let response;
            if (row.selic_cdi_ipca_id) {
                response = await SelicCdiIpcaAPI.update(payload);
            } else {
                response = await SelicCdiIpcaAPI.save(payload);
            }

            if (!response.success) {
                allSuccess = false;
                break;
            }
        }

        dispatch(allActions.mainAlertActions.setMainAlert({
            show: true,
            type: allSuccess ? 'success' : 'error',
            message: allSuccess
                ? 'Índices ' + content.data.year + ' atualizados com sucesso!'
                : 'Falha ao atualizar índices!',
        }));

        setOpenBackdrop(false);
        dispatch(allActions.rightContentActions.update());
    }

    useEffect(() => {
        if (content && content.data) {
            initInputs(content.data);
        }
    }, []);

    return (
        <div className={classes.root}>

            <div className={classes.header}>
                <div className={classes.leftHeader}>
                    <Typography align={'left'} className={classes.dateLabel}>
                        <EventIcon />{content && content.data ? content.data.year : ''}
                    </Typography>
                    <Typography align={'left'} className={classes.accountLabel}>
                        <span>{'SELIC Acum: '}<span style={{ color: 'blue' }}>{content.data.selicAcum + '%'}</span></span>
                        <span className={classes.spacingLeft2}>{'CDI Acum: '}<span style={{ color: 'blue' }}>{content.data.cdiAcum + '%'}</span></span>
                        <span className={classes.spacingLeft2}>{'IPCA Acum: '}<span style={{ color: 'blue' }}>{content.data.ipcaAcum + '%'}</span></span>
                    </Typography>
                </div>
                <IconButton onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                    <CloseIcon />
                </IconButton>
            </div>

            <div className={classes.main}>
                <TableContainer component={Paper} elevation={0}>
                    <Table className={classes.table} stickyHeader size="small">
                        <colgroup>
                            <col width="28%" />
                            <col width="24%" />
                            <col width="24%" />
                            <col width="24%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.leftPadding24} align="left">MÊS</TableCell>
                                <TableCell align="center">SELIC</TableCell>
                                <TableCell align="center">CDI</TableCell>
                                <TableCell align="center">IPCA</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className={classes.table}>
                            {months.map((row) => {
                                const idx = parseInt(row.id) - 1;
                                return (
                                    <TableRow className={classes.detailRow} key={'selic-cdi-ipca-month-' + row.id}>
                                        <TableCell align="left">{row.name}</TableCell>
                                        <TableCell align="left">
                                            <MyTextField
                                                align="right"
                                                onChange={(value) => handleChange('selic', value, idx)}
                                                value={inputs[idx].selic}
                                                verysmall
                                                placeholder="0.00"
                                                size={'small'}
                                                variant="outlined" />
                                        </TableCell>
                                        <TableCell align="left">
                                            <MyTextField
                                                align="right"
                                                onChange={(value) => handleChange('cdi', value, idx)}
                                                value={inputs[idx].cdi}
                                                verysmall
                                                placeholder="0.00"
                                                size={'small'}
                                                variant="outlined" />
                                        </TableCell>
                                        <TableCell align="left">
                                            <MyTextField
                                                align="right"
                                                onChange={(value) => handleChange('ipca', value, idx)}
                                                value={inputs[idx].ipca}
                                                verysmall
                                                placeholder="0.00"
                                                size={'small'}
                                                variant="outlined" />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>

                <div className={classes.bottom}>
                    <UnoButton
                        onClick={() => doSave(inputs)}
                        className={classes.spacingRight2}
                        type='primary'
                        size={'small'}>
                        {'Salvar índices'}
                    </UnoButton>
                </div>
            </div>

            {openBackdrop ?
                <div className={classes.rightDivBackdrop}>
                    <CircularProgress className={'progress'} />
                </div> : null
            }
        </div>
    );
}
